// extracted by mini-css-extract-plugin
export default {"closedRegistrationMessageContainer":"V6TWt","closedRegistrationMessage":"m520U"};